<div class="p-fluid p-grid">
  <div class="p-col-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Nome" [restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
  <div class="p-col-12 p-lg-9">
    <p-card header="Lista de Usuários">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        responsiveLayout="scroll"
        styleClass="p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="id">Id <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
              <th pSortableColumn="login">login <p-sortIcon field="login"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entity>
          <tr>
              <td class="p-text-center">{{entity.id}}</td>
              <td>{{entity.nome}}</td>
              <td>{{entity.login}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6">
              <a pButton (click)="abrirCriaUsuarioSistemaModal()" class="p-primary" label="Novo"></a>
            </div>
            <div class="p-field p-col-6">
              <a pButton (click)="abrirImportarUsuarioSistemaModal()" class="p-button-info" label="Importar"></a>
            </div>
            <div class="p-field p-col-12 p-text-right">
              Quantidade de registros: <span class="p-text-bold"> {{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

<p-dialog
  header="Criar novo usuário de Sistema"
  [showHeader]="true"
  [visible]="mostrarCriaUsuarioSistemaModal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '90%', maxWidth: '800px'}"
  appendTo="body">
  <div style="width: 100%">
    <div *ngIf="!usuarioCriado" style="text-align: center; margin: 1em 0">
      <p>Preencha os campos abaixo para criar um novo usuário de sistema:</p>
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="login">Login:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="login" [(ngModel)]="login" (ngModelChange)="validarFormulario()" />
            <div *ngIf="loginInvalido" style="color: red; font-size: 0.9em;">
              O campo login só pode conter letras minúsculas, números, “_” e “-” e não pode ser um CPF.
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="nome">Nome:</label>
          </div>
          <div class="p-col-12 p-lg-3">
            <input pInputText type="text" name="nomePrefix" [ngModel]="'Sistema'" disabled />
          </div>
          <div class="p-col-12 p-lg-7">
            <input pInputText type="text" name="nomeSufixo" [(ngModel)]="nomeSufixo" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="senha">Senha:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="password" name="senha" [(ngModel)]="senha" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button (click)="fecharCriaUsuarioSistemaModal()" pButton type="button" label="Cancelar" class="p-button-danger" style="margin-right: 8px;"></button>
        <button (click)="criarUsuarioSistema()" pButton type="button" [disabled]="!validarFormulario() || carregando">
          <span *ngIf="!carregando">Salvar</span>
          <span *ngIf="carregando" class="pi pi pi-spin pi-spinner"></span>
        </button>
      </div>
    </div>
    <div *ngIf="usuarioCriado">
      <div style="text-align: center; margin: 1em 0">
        <p *ngIf="usuarioCriado.existenteNoSSO">O usuário foi importado no CODEX, mas já estava registrado no SSO, por isso a senha prévia foi mantida.</p>
        <p *ngIf="!usuarioCriado.existenteNoSSO">Usuário criado com sucesso!</p>
        <a pButton [routerLink]="['/usuario/visualizar/', usuarioCriado.usuario.id]" class="p-button-sm p-m-r-2" pTooltip="Visualizar usuário criado">OK</a>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Importar usuário ao Sistema"
  [showHeader]="true"
  [visible]="mostrarImportarUsuarioSistemaModal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '90%', maxWidth: '800px'}"
  appendTo="body">
  <div style="width: 100%">
    <div *ngIf="!usuarioCriado" style="text-align: center; margin: 1em 0">
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="login">Usuário:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="login" id="login" [(ngModel)]="login" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button (click)="fecharImportarUsuarioSistemaModal()" pButton type="button" label="Cancelar" class="p-button-danger" style="margin-right: 8px;"></button>
        <button (click)="importarUsuarioSistema()" pButton type="button"  [disabled]="!login">
          <span *ngIf="!carregando">Importar</span>
          <span *ngIf="carregando" class="pi pi pi-spin pi-spinner"></span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>
